<!-- 优惠互斥样式组件 -->
<template>
  <div class="content">
    <el-checkbox-group
      v-model="MutexdataPage"
      @change="$emit('changeOption', MutexdataPage)"
    >
      <div
        class="activity-cont"
        v-if="
          sendStatus ? this.$parent.$parent.HY : this.$parent.$parent.Isdiscount
        "
      >
        <span>
          <el-checkbox label="3">会员优惠</el-checkbox>
          <span class="hint" v-if="this.$parent.$parent.discount_dec">
            ( {{ this.$parent.$parent.discount_dec }} )</span
          >
          <span style="color:#cccccc;font-size: 14px"> </span>
        </span>
        <span
          :style="newData.discount ? 'color:#f56c6c' : 'color:#cccccc'"
          v-text="
            newData.discount
              ? '-' + newData.discount_dec_money + '元'
              : '暂无优惠'
          "
        >
        </span>
      </div>
      <div
        class="activity-cont"
        v-if="
          sendStatus ? this.$parent.$parent.PTK : this.$parent.$parent.Isplatform
        "
      >
        <span>
          <el-checkbox label="4">平台卡优惠</el-checkbox>
          <span class="hint" v-if="this.$parent.$parent.platform_dec">
            ( {{ this.$parent.$parent.platform_dec }} )</span
          >
          <span style="color:#cccccc;font-size: 14px"> </span>
        </span>
        <span
          :style="newData.platform_dec_money ? 'color:#f56c6c' : 'color:#cccccc'"
          v-text="
            newData.platform_dec_money
              ? '-' + newData.platform_dec_money + '元'
              : '暂无优惠'
          "
        >
        </span>
      </div>
      <div
        class="activity-cont"
        v-if="
          sendStatus ? this.$parent.$parent.Yhq : this.$parent.$parent.Iscoupon
        "
      >
        <span>
          <el-checkbox label="2">优惠券</el-checkbox>
          <span class="hint"> ( 已使用{{ useNum }}张 )</span>
        </span>
        <span @click="$emit('openConponList', false)" style="cursor: pointer;">
          <span style="color:rgb(245, 108, 108)">{{ bottom_ticket }}</span>
        </span>
      </div>
      <div
        class="activity-cont"
        v-if="
          sendStatus ? this.$parent.$parent.jf : this.$parent.$parent.Ispoint
        "
      >
        <span>
          <el-checkbox label="1">积分</el-checkbox>
          <span class="hint"> ( - {{ dedIntegral }}积分 )</span>
          <!--          <span class="hint">({{ integralNum }}积分可用)</span>-->
        </span>
        <span v-if="dedIntegralMoney == 0 && dedIntegral == 0">
          <span style="color:#cccccc;">暂无优惠</span>
        </span>
        <span v-else>
          <span style="color:rgb(245, 108, 108)"
            >-{{ dedIntegralMoney }}元</span
          >
        </span>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: [
    "sendStatus",
    "useNum",
    "bottom_ticket",
    "integralNum",
    "dedIntegral",
    "dedIntegralMoney",
    "newData",
    "mutexData",
    "optionMutex",
  ],
  watch: {
    optionMutex(val) {
      this.MutexdataPage = val;
      console.log("shuju ", val);
    },
    mutexData: {
      handler(val) {
        console.log("shuju 3", val);
      },
      deep: true,
      immediate: true
    },
    Radios(val) {
      this.Radio = val;
      console.log("shuju2 ", val);
    },
    newData: {
      handler(val) {
        if(JSON.stringify(val)!=='{}'){
          this.checkbox = val.mutex.checkbox;
          this.radio = val.mutex.radio;
          this.dan(val.mutex.radio);
          this.duo(val.mutex.checkbox);
        }
        console.log("zi", val);
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      Radio: "",
      MutexdataPage: [],
      checkbox: {},
      radio: {},
      radioArr: [],
      checkboxArr: []
    };
  },
  mounted() {
    this.$nextTick(()=>{
      this.Radio = this.$parent.$parent.Radio;
      this.MutexdataPage = this.$parent.$parent.optionMutex;
      console.log("fu", this.$parent.$parent.HY);
    })
   
  },
  components: {},
  methods: {
    dan(obj) {
      let arr = [];
      if (!Array.isArray(obj)) {
        for (let i in obj) {
          arr.push({
            ...this.radio[i],
            type: i
          });
        }
        this.radioArr = arr;
      }
    },
    duo(obj) {
      let arr = [];
      if (!Array.isArray(obj)) {
        for (let i in obj) {
          arr.push({
            ...this.radio[i],
            type: i
          });
        }
        this.checkboxArr = arr;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-cont {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  line-height: 20px;
  height: 20px;
  .hint {
    font-size: 14px;
    color: #999;
    margin-right: 5px;
  }
}
.activity-cont:last-child {
  margin-bottom: 0px;
}
</style>
